import { lazy, ComponentType } from "react";

/**
 * Wraps React.lazy with automatic page reload retry if a dynamic module fails to fetch
 * (e.g. after a new site deployment when chunk hashes update).
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    const pageHasAlreadyBeenReloaded = JSON.parse(
      sessionStorage.getItem("chunk_retry_reloaded") || "false"
    );

    try {
      const component = await factory();
      sessionStorage.setItem("chunk_retry_reloaded", "false");
      return component;
    } catch (error: any) {
      const msg = error?.message || "";
      const isChunkError =
        msg.includes("Failed to fetch dynamically imported module") ||
        msg.includes("Importing a module script failed") ||
        error?.name === "ChunkLoadError";

      if (isChunkError && !pageHasAlreadyBeenReloaded) {
        sessionStorage.setItem("chunk_retry_reloaded", "true");
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }

      throw error;
    }
  });
}
